import { MinimalCertificateDisplayType, MinimalCertificateState } from '../interfaces/interface.minimal-certificate-offer';
import { Valuation } from '../interfaces/interface.offer';
import { DISPOSAL_TYPES } from '../utils/utils.offer';
import { createExtendedStore } from '../utils/utils.store';

type OfferState = typeof initialState & MinimalCertificateState;

const initialState = {
  accidentQuestionModifiedByDealer: false,
  amount: 0,
  formattedFinalOfferAmount: '',
  offerId: '',
  hasDealerBoost: false,
  expirationDate: '',
  originalExpirationDate: '',
  isAssignedOffer: false,
  isExpired: false,
  dealerId: 0,
  dealerRepId: 0,
  status: '',
  isConsumerOffer: true,
  channelId: '',
  isExclusiveOffer: false,
  dealerBoostAmount: 0,
  isEligible: true,
  isFurtherReviewNeeded: false,
  isInspectionNeeded: false,
  isOfficeClosed: false,
  isOfferUnderReview: false,
  isIneligibleOffer: false,
  prospectId: '',
  dealerComment: '',
  sentToDealers: [],
  offerImages: [],
  appointmentsEnabled: false,
  vehicleConditions: [], // display purposes only
  vehicleModifications: [], // display purposes only,
  vehicleHistory: [], // display purposes only
  vehicleOdor: [], // display purposes only
  showCustomerIneligibleNextSteps: false,
  isDrOffer: false,
  showCustomerDealerList: true,
  showDealerListForPrint: true,
  useTradeIn: false,
  displayRequestAppointmentButton: true,
  showOfferPriceButton: true,
  showOfferPriceDRButton: true,
  offerPriceDrButtonText: '',
  isCobrandingAssigned: false,
  isCobrandingUnassigned: false,
  isCobrandingDRUnassigned: false,
  isCobrandingDRAssigned: false,
  tradeInBtnText: '',
  inProgressBtnText: '',
  offerCode: '',
  potentialTaxSaving: 0,
  showIcoQuestionsSection: true,
  offerError: 0,
  primaryBodyStyle: '',
  canBeResubmitted: true,
  enableMileageIneligibleEditing: false,
  canEditMileageIneligible: false,
  minimumMileageIneligibleThreshold: 0,
  showDealerList: false,
  showDealerChosenReasons: true,
  ineligibleReasons: '',
  isKelleyBuysYourCar: false,
  minimalCertificateDisplayType: MinimalCertificateDisplayType.NotAvailable,
  disposalType: DISPOSAL_TYPES.ICO,
  kbbOptionAdjustment: null,
  valuation: [] as Valuation[],
  conditionTierSelection: '',
  currentWeeklyDepreciation: null,
};

const { on, onChange, state, reset, partialReset } = createExtendedStore(initialState);

export { initialState, on, onChange, state, reset, partialReset, OfferState };
export default state;
